






























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as _ from 'lodash';
import { removeFrontZone } from '../../../utils/string';
import { updateAnomalyQty, deleteAnomalyQty, getAnomalyQuantitys } from '../../../api/pickup';

@Component({
  name: 'AnomalyQtyDialog',
})
export default class extends Vue {
  @Prop({ required: true }) private date!: string;

  @Prop({ required: true }) private locationCode!: string;

  @Watch('dialog')
  onChangeValue(newVal: boolean) {
    if (newVal === false) {
      this.resetForm();
    }
  }

  private id = '';

  private driverName = '';

  private driverNumber = '';

  private stationNumber = '';

  private itemNumber = '';

  private itemCode = '';

  private itemName = '';

  private expectedQty = '';

  private actualQty = '';

  private type = '库存不足';

  private comment = '';

  private dialog = false;

  private types: string[] = ['库存不足'];

  private valid = false;

  private actualQtyRules = [(v: any) => !!v || 'Actual QTY is required'];

  private typeRules = [(v: any) => !!v || 'Type is required'];

  private commentRules = [];

  public async open(
    item: any,
    itemNumber: string,
    itemName: string,
    expectedQty: any,
    stationNumber: string,
  ) {
    this.$overlay(true);
    this.driverName = item.driver_name;
    this.driverNumber = item.driver_number;
    this.itemNumber = itemNumber;
    this.itemCode = removeFrontZone(itemNumber);
    this.itemName = itemName;
    this.expectedQty = expectedQty;
    this.stationNumber = stationNumber;

    const anomalyQty = await this.getAnomalyQuantity();
    if (anomalyQty !== undefined) {
      this.id = anomalyQty.id;
      this.actualQty = anomalyQty.quantity;
      this.type = anomalyQty.type;
      this.comment = anomalyQty.comment;
    }

    this.$overlay(false);
    this.dialog = true;
    this.resetValidation();
  }

  private async getAnomalyQuantity() {
    const { data } = await getAnomalyQuantitys(this.date, this.locationCode);
    return _.find(data, {
      driver_number: this.driverNumber,
      item_number: this.itemNumber,
      station_number: this.stationNumber,
    });
  }

  private save() {
    (this.$refs.form as Vue & { validate(): () => void }).validate();
    if (this.valid) {
      this.$confirm('Are you sure save?').then((result) => {
        if (result) {
          this.updateAnomalyQty();
        }
      });
    }
  }

  private destroy() {
    this.$confirm('Are you sure delete?').then((result) => {
      if (result) {
        this.destroyAnomalyQty();
      }
    });
  }

  private resetValidation() {
    if (this.$refs.form) {
      (this.$refs.form as Vue & { resetValidation(): () => void }).resetValidation();
    }
  }

  private resetForm() {
    this.id = '';
    this.actualQty = '';
    this.type = '库存不足';
    this.comment = '';
    this.driverName = '';
    this.driverNumber = '';
    this.itemNumber = '';
    this.itemCode = '';
    this.itemName = '';
    this.expectedQty = '';
    this.stationNumber = '';
  }

  private async updateAnomalyQty() {
    this.$overlay(true);
    const { data } = await updateAnomalyQty(
      this.date,
      this.locationCode,
      this.itemNumber,
      this.driverNumber,
      this.actualQty,
      this.stationNumber,
      this.type,
      this.comment,
    );
    this.$overlay(false);
    this.$emit('save', {
      driver_number: this.driverNumber,
      item_number: this.itemNumber,
      station_number: this.stationNumber,
      anomaly: data,
    });
    this.dialog = false;
  }

  private async destroyAnomalyQty() {
    this.$overlay(true);
    await deleteAnomalyQty(this.id);
    this.$overlay(false);
    this.$emit('destroy', {
      driver_number: this.driverNumber,
      item_number: this.itemNumber,
      station_number: this.stationNumber,
    });
    this.dialog = false;
  }
}
